export const auth = {
  failed: "Authentifizierung fehlgeschlagen"
};
